<template>
  <v-dialog v-model="opened" :persistent="persistent">
    <v-card class="basic-modal" elevation="4">
      <v-card-title class="d-flex justify-space-between">
        <h6 class="heading--text d-flex align-center">
          <v-icon size="24" class="mr-4" color="info">$database</v-icon>
          <span>{{ $t("heading.instance.phpmyadminSsoChoice.title") }}</span>
        </h6>
        <v-btn v-if="!submitting" icon x-small @click="close()">
          <v-icon size="24">$close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <p class="mb-4 p-2" v-if="submitting">
          {{ $t("heading.instance.phpmyadminSsoChoice.message") }}
        </p>
        <div v-if="dnsMismatchDetected" class="warning-box my-5">
          <v-icon color="warning" size="20" class="mr-2">$alertcircle</v-icon>
          <span class="warning--text">{{ $t("notification.instance.modal.phpmyadminSsoChoice.dnsMismatch") }}</span>
        </div>

        <v-form v-if="showDatabaseSelect" class="d-flex flex-column">
          <div class="d-flex flex-column">
            <label class="base--text mb-2">
              {{ $t("form.label.database") }}
            </label>
            <div class="last-child">
              <v-select
                outlined
                v-model="databaseId"
                :items="databases"
                item-text="label"
                item-value="value"
                hide-details="auto"
                dense
                append-icon="$dropdown"
                :menu-props="{ offsetY: true }"
              />
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions class="d-flex flex-wrap pb-4">
        <div class="w-100 pb-2">
          <v-row>
            <v-col>
              <v-btn
                :text="false"
                large
                block
                elevation="0"
                class="primary"
                :loading="submitting && submittingAction === 'preview'"
                :disabled="submitting"
                @click="loginPreview()"
              >
                <span class="p-2 font-weight-600">
                  {{ $t("button.loginWithTempUrl") }}
                </span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                :text="false"
                large
                block
                elevation="0"
                class="gray"
                :loading="submitting && submittingAction === 'default'"
                :disabled="submitting"
                @click="loginDefault()"
              >
                <span class="p-2 font-weight-600">
                  {{ $t("button.loginDirectly") }}
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div class="w-100 pb-2 cancel-btn">
          <v-btn
            :text="true"
            large
            block
            elevation="0"
            class="nornal"
            :disabled="submitting"
            @click="close()"
          >
            <span class="p-2 font-weight-bold gray--text text--darken-1">
              {{ $t("button.cancel") }}
            </span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/apis/Api";

export default {
  name: "PhpMyAdminSsoModal",
  data() {
    return {
      opened: false,
      persistent: false,
      submitting: false,
      submittingAction: null,
      //
      hostingAccountId: null,
      serverType: null,
      databases: [],
      databaseId: null,
      //
      dnsMismatchDetected: false,
    };
  },
  computed: {
    showDatabaseSelect() {
      return this.serverType === "plesk" && Array.isArray(this.databases) && this.databases.length > 1;
    },
  },
  methods: {
    open({ hostingAccountId, serverType, databases, dnsMismatchDetected }) {
      this.hostingAccountId = hostingAccountId;
      this.serverType = serverType;
      this.databases = Array.isArray(databases) ? databases : [];
      this.databaseId = this.databases.length ? this.databases[0].value : null;
      this.dnsMismatchDetected = !!dnsMismatchDetected;
      this.submitting = false;
      this.submittingAction = null;
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    async loginDefault() {
      return this.login({
        endpoint: `/server-accounts/${this.hostingAccountId}/mysql/phpmyadmin-sso-url`,
        action: "default",
      });
    },
    async loginPreview() {
      return this.login({
        endpoint: `/server-accounts/${this.hostingAccountId}/mysql/phpmyadmin-preview-sso-url`,
        action: "preview",
      });
    },
    async login({ endpoint, action }) {
      if (this.submitting) return;
      this.persistent = true;
      this.submitting = true;
      this.submittingAction = action;
      try {
        const payload = {};
        if (this.serverType === "plesk" && this.databaseId) {
          payload.database_id = this.databaseId;
        }
        const response = await Api.post(endpoint, payload);
        const url = response?.data?.data?.url;
        if (url) {
          window.open(url);
          this.close();
        }
      } catch (error) {
        this.$store.dispatch("addAlert", {
          success: false,
          errorMessage: Api.getErrorMessage(error),
        });
      } finally {
        this.persistent = false;
        this.submitting = false;
        this.submittingAction = null;
      }
    },
  },
};
</script>

<style src="./BasicModal.scss" lang="scss" scoped />